import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Location } from "@angular/common";
@Component({
  selector: "ngx-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgetPasswordComponent {
  forgetPasswordForm = this.fb.group({
    email: [
      "",
      [
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$"),
      ],
    ],
  });
  translate: "COMMON.GoBack";
  // location: any;

  constructor(public fb: FormBuilder, private readonly location: Location) { }
  goBackBtn() {
    this.location.back();
  }

  requestPassword() {
    if (this.forgetPasswordForm.valid) {
      console.log(this.forgetPasswordForm.valid)
    }
  }
}
